import React, { useState } from "react";

import { Dropdown } from "@bps/fluent-ui";

import { AssignDeploymentRingForm } from "./Actions/AssignDeploymentRing";
import { AssignTenantDeploymentRingForm } from "./Actions/AssignTenantDeploymentRing";
import { BulkAuthActionForm } from "./Actions/AuthAction";
import { SendBulkCommandForm } from "./Actions/SendCommand";
import { UnassignTenantDeploymentRingForm } from "./Actions/UnassignTenantDeploymentRing";
import { ActionTypeOptions, BulkActionType } from "./formTypes";

export const BulkActionsForm: React.FC = () => {
  const [formType, setFormType] = useState<string>();

  return (
    <>
      <Dropdown
        options={ActionTypeOptions}
        label="Action Type"
        name="actionType"
        placeholder="Please select..."
        required
        styles={{ root: { width: "30%", minWidth: 300 } }}
        onChange={(_, item) => {
          setFormType(String(item?.key));
        }}
      />

      {formType === BulkActionType.AssignDeploymentRing && (
        <AssignDeploymentRingForm />
      )}

      {formType === BulkActionType.AssignTenantDeploymentRing && (
        <AssignTenantDeploymentRingForm />
      )}

      {formType === BulkActionType.UnassignTenantDeploymentRing && (
        <UnassignTenantDeploymentRingForm />
      )}

      {formType === BulkActionType.AuthAction && <BulkAuthActionForm />}

      {formType === BulkActionType.SendCommand && <SendBulkCommandForm />}
    </>
  );
};
